import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Dropdown, DropdownButton, SimpleDropdownItem } from "@similarweb/ui-components";

import type { IosIdentifierType } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/types";
import { iosIdentifierTypeToAppsIdentifiers } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/utils";
import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";

import { StyledDropdownContainer } from "./styles";

interface Props {
    value: IosIdentifierType;
    onUpdate: (value: IosIdentifierType) => void;
    options: IosIdentifierType[];
}

export const IosIdentifierDropdown: React.FC<Props> = ({ value, onUpdate, options }) => {
    const renderItems = () =>
        options.map((identifierType) => (
            <SimpleDropdownItem
                key={identifierType}
                id={identifierType}
                selected={value === identifierType}
            >
                {iosIdentifierTypeToAppsIdentifiers[identifierType]}
            </SimpleDropdownItem>
        ));

    const handleSelect = (item: { id: IosIdentifierType }) => {
        onUpdate(item.id);
    };

    return (
        <StyledDropdownContainer id="ios-identifier-dropdown">
            <Dropdown
                appendTo="#ios-identifier-dropdown"
                onClick={handleSelect}
                width={116}
                dropdownPopupPlacement="ontop-left"
            >
                {[
                    <StyledBaseDropdownButtonWrap
                        key="dropdown-button"
                        buttonTextColor={colorsPalettes.carbon[400]}
                    >
                        <DropdownButton>{iosIdentifierTypeToAppsIdentifiers[value]}</DropdownButton>
                    </StyledBaseDropdownButtonWrap>,
                ].concat(renderItems())}
            </Dropdown>
        </StyledDropdownContainer>
    );
};
